import React from "react";
import { useSearchParams } from 'react-router-dom';
import { SpinnerFullPage } from "shared/components/SpinnerFullPage";
import { accountService } from "inter-service/account";

export function Login() {
  const [searchParams] = useSearchParams();
  const from = searchParams.get('from') || undefined;
  const loginRedirectUrl = accountService.generateUrlToLoginPage({ from });
  window.location.replace(loginRedirectUrl);
  return <SpinnerFullPage />;
}
